import SocialBtn from 'components/buttons/SocialBtn'
import { useHistory } from 'react-router-dom'
import * as nativeApp from 'utils/nativeApp'
import Loading from 'components/Loading'
import { createPortal } from 'react-dom'
import { useReduxSelector } from 'store'
import { selectConfig } from 'appSlice'
import React, { useState } from 'react'
import { POST } from 'rest/request'
import * as urls from 'rest/urls'

const overlayStyle: React.CSSProperties = {
  position: 'fixed',
  inset: 0,
  zIndex: 9999,
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  background: 'var(--theme-bg)',
}

const SocialButtons: React.FC = () => {
  const config = useReduxSelector(selectConfig)
  const { push } = useHistory()
  const [isAppleLoading, setIsAppleLoading] = useState(false)

  const appleNative = !!config?.oauth?.appleNative && nativeApp.checkNativeAppleSignInSupport()

  const openAppleWeb = () => {
    if (!config?.oauth?.apple) return
    if (nativeApp.checkIsAndroid()) {
      nativeApp.openAuth(config.oauth.apple)
    } else {
      window.open(config.oauth.apple, '_self')
    }
  }

  const signInWithAppleNatively = async () => {
    if (isAppleLoading) return
    try {
      const payload = await nativeApp.requestNativeAppleSignIn()
      setIsAppleLoading(true)
      const response = await POST(`${urls.oauth}/apple/native`, { body: payload })
      if (response?.magic_token) {
        push(`/oauth/finish?magic_token=${encodeURIComponent(response.magic_token)}`)
      } else {
        setIsAppleLoading(false)
      }
    } catch (error: any) {
      setIsAppleLoading(false)
      if (error?.code === 'apple_cancelled') return
      if (error?.code === 'apple_unavailable') {
        openAppleWeb()
        return
      }
      console.error(error)
    }
  }

  return (
    <>
      {isAppleLoading && createPortal(
        <div style={overlayStyle}>
          <Loading />
        </div>,
        document.body
      )}

      {(config?.oauth?.apple || appleNative) && <SocialBtn
        type='apple'
        onClick={() => {
          if (appleNative) {
            signInWithAppleNatively()
          } else {
            openAppleWeb()
          }
        }} />}
      {config?.oauth?.google && <SocialBtn
        type='google'
        onClick={() => {
          if (!config.oauth?.google) return
          if (nativeApp.checkIsNativeApp()) {
            nativeApp.openAuth(config.oauth.google)
          } else {
            window.open(config.oauth.google, '_self')
          }
        }} />}
    </>
  )
}

export default SocialButtons